import isFieldVisible from './isFieldVisible';

// Given a form and a field name, returns the value of that field or undefined if the
// field is unchecked etc
export function formFieldValue(form, name, defaultValue){
  const values = formFieldValues(form, name);
  if(values.length) {
    return values[0];
  } else {
    return defaultValue;
  }
}

// Given a form and a field name, returns whether the field is checked
export function formFieldChecked(form, name){
  return [...form.querySelectorAll(`[name="${name}"]`)].some(field => field.checked);
}

// Given a form and a field name, returns an array of all values of inputs matching that name
export function formFieldValues(form, name) {
  if(name) {
    return formSelectorValues(form, `[name="${name}"]`);
  } else {
    return [];
  }
}

// Given a form and a field name, returns an array of all visible
// values of inputs matching that name
export function formSelectorValues(form, selector) {
  return [...form.querySelectorAll(selector)]
    .filter((field) => isFieldVisible(field) && !field.disabled)
    .map((field) =>  fieldValue(field))
    .filter((value) => value != null);
}

function fieldValue(field) {
  if(field.tagName === 'SELECT') {
    return selectValue(field);
  } else if (['checkbox', 'radio'].indexOf(field.type) > -1) {
    return checkValue(field);
  } else {
    return field.value;
  }
}

function checkValue(field) {
  return field.checked ? field.value : undefined;
}

function selectValue(field) {
  const option = field.options[field.selectedIndex];
  return option ? option.value : undefined;
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/selectors/formFieldValue.js